const getEmailUsUrl = location => {
  const uriEncodedLocation = encodeURIComponent(location);
  const emailPage = "/email-us";
  return location ? `${emailPage}?source=${uriEncodedLocation}` : emailPage;
};

export default getEmailUsUrl;
